<div role="contentinfo" class="footer text-white text-center">
  <div class="footer-quicklinks bg-black w-100"></div>
  <div class="footer-text bg-white text-black d-flex align-items-center justify-content-center w-100">
    <div class="footer-content mt-lg-3 mt-2">
      <img
        alt="fortress image footer"
        class="footer-logo mb-2"
        [src]="'images/footer-fortress.png' | contentAssetImage"
        draggable="false"
      />
      <p class="text-black font-size-12 text-center">
        {{ 'nav.club.rights' | translate }}
      </p>
    </div>
  </div>
</div>
